import { useEffect, useState } from "react";
import api from "@/lib/api";
import { LineChart, Line, ResponsiveContainer, Tooltip, YAxis, XAxis } from "recharts";

export function MiniSparkline({ hotelId, days = 30, height = 40 }) {
  const [data, setData] = useState([]);
  useEffect(() => {
    api.get(`/hotels/${hotelId}/score-history?days=${days}`).then((r) => {
      setData((r.data || []).map((p) => ({ data: p.data, punteggio: p.punteggio })));
    }).catch(() => setData([]));
  }, [hotelId, days]);

  if (data.length === 0) return <div className="h-10 rounded-md bg-muted/30 animate-pulse" />;

  const min = Math.min(...data.map((d) => d.punteggio));
  const max = Math.max(...data.map((d) => d.punteggio));
  const last = data[data.length - 1].punteggio;
  const first = data[0].punteggio;
  const trend = last >= first ? "#10b981" : "#f43f5e";

  return (
    <div className="w-full" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 4, right: 4, left: 4, bottom: 4 }}>
          <YAxis hide domain={[Math.max(0, min - 5), Math.min(100, max + 5)]} />
          <Line type="monotone" dataKey="punteggio" stroke={trend} strokeWidth={1.8} dot={false} isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export function FullSparkline({ hotelId, days = 30, height = 220 }) {
  const [data, setData] = useState([]);
  useEffect(() => {
    api.get(`/hotels/${hotelId}/score-history?days=${days}`).then((r) => {
      setData((r.data || []).map((p) => ({
        data: new Date(p.data).toLocaleDateString("it-IT", { day: "2-digit", month: "short" }),
        punteggio: p.punteggio,
      })));
    }).catch(() => setData([]));
  }, [hotelId, days]);

  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 10, right: 16, left: 0, bottom: 0 }}>
          <XAxis dataKey="data" tick={{ fontSize: 10, fill: "hsl(var(--muted-foreground))" }} interval="preserveStartEnd" minTickGap={32} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 10, fill: "hsl(var(--muted-foreground))" }} domain={[40, 100]} axisLine={false} tickLine={false} />
          <Tooltip contentStyle={{ background: "rgba(255,255,255,0.95)", borderRadius: 12, border: "1px solid hsl(var(--border))", fontSize: 12 }} />
          <Line type="monotone" dataKey="punteggio" stroke="#a574d3" strokeWidth={2.2} dot={{ r: 2, fill: "#a574d3" }} activeDot={{ r: 5 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
